import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import AsiacellService from "./../../../Utilies/Utilies/AsiacellService";
import logo from "./../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import grandLogo from "./../../../assets/imgs/logo2.png";
import Layout from "../../../Components/layout";
import { useTranslation } from "react-i18next";
import "./aciqSignup.css";

export default function AciqSignup() {
    const { i18n, t } = useTranslation();
   useEffect(() => {
      document.body.dir = i18n.dir();
    }, [i18n, i18n.language]);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSub, setShowSub] = useState(true);
  const [isOTP, setIsOTP] = useState(false);
  const [otp, setOtp] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);
  const [headerData, setHeaderData] = useState({});
  const [clickId, setClickId] = useState("");
  const [mcpuniqid, setMcpuniqid] = useState("");
  const [enriched, setEnriched] = useState(false);
  const [manualMsisdn, setManualMsisdn] = useState("");
  const [showMsisdnInput, setShowMsisdnInput] = useState(false);

  useEffect(() => {
    // Save traffic params
    const parameter = params.get("parameter");
    const trafficsource = params.get("trafficsource");
    if (parameter) localStorage.setItem("parameter", parameter);
    if (trafficsource) localStorage.setItem("trafficsource", trafficsource);
    fetchHeader();
  }, []);

  const fetchHeader = async () => {
    try {
      const data = await AsiacellService.getPhoneByHeader();
      console.log("data", data);

      if (data.Msisdn) {
        // Auto-login flow
        localStorage.setItem("msisdn", data.Msisdn);
        doHeaderSignup(data);
        setShowSub(false);
      } else {
        // Show input
        doHeaderSignup(data);

        setShowMsisdnInput(true);
      }
    } catch {

      setShowMsisdnInput(true);
    }
  };

  const doHeaderSignup = async (header) => {
    const body = {
      headers: header.Headers,
      msisdn: header.Msisdn,
      pageid: "1",
    };

    try {
      const res = await AsiacellService.getScript(body);

      if (res && res.data) {
        const script = document.createElement("script");
        script.innerHTML = res.data.message;
        document.head.appendChild(script);
        setClickId(res.data.clickId ?? "");
        const MCPuniqid =
          res.data.MCPuniqid ;
          setMcpuniqid(MCPuniqid);
       
        setEnriched(true);
        setShowLoading(false);
      } else {
        setShowError(true);
        setErrorMessage(res.message);
      }
    } catch (err) {
      setShowError(true);
    }
  };

  const signup = () => {
    if (isMobile()) {
      window.location.href = "sms:2231;?&body=1";
    } else {
      setVisibleModal(true);
      setTimeout(() => setVisibleModal(false), 5000);
    }
  };
  const IQ_ASIACELL_MSISDN_RE = /^96477\d{8}$/;
  const isValidIqAsiacellMsisdn = (value) => IQ_ASIACELL_MSISDN_RE.test(value);

  const handleManualMsisdnChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 13);
    setManualMsisdn(digits);
    if (showError) setShowError(false);
  };

  const manualSubscribe = async () => {
    if (!manualMsisdn) {
      setErrorMessage("من فضلك أدخل رقم الهاتف");
      setShowError(true);
      return;
    }
    if (!isValidIqAsiacellMsisdn(manualMsisdn)) {
      setErrorMessage(t("aciq_phone_invalid"));
      setShowError(true);
      return;
    }

    try {
      setShowLoading(true);
      const res = await AsiacellService.sendPinNonHeader(manualMsisdn, clickId);

      setShowLoading(false);

      if (res.success) {
        // Save msisdn
        localStorage.setItem("msisdn", manualMsisdn);
        navigate(`/verify-asiacell?uniqid=${mcpuniqid}`);
      } else {
        setShowError(true);
        setErrorMessage(res.message || "حدث خطأ برجاء المحاولة");
      }
    } catch (err) {
      setShowLoading(false);
      setShowError(true);
      setErrorMessage("خطأ في الإتصال بالخادم");
    }
  };

  const confirmSubscribe = () => {
    //  if (enriched && mcpuniqid) {
    navigate(`/confirm-asiacell?uniqid=${mcpuniqid}`);
    //  } else {
    // signup();
    // }
  };

  const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);

  return (
    <>
      {/* Main Design */}
     <Layout reloadOnLanguageChange>
  <div className="bg-item">
    <div className="aciq-signup-outer d-flex justify-content-center align-items-center">
      <div className="aciq-signup-wrap">
        <div>

          {/* Logo */}
          <div className="row d-flex justify-content-center mt-2">
            <img className="servImg" src={logo} alt="" />
          </div>

          {/* Free Days Title */}
          <div className="fw-bold text-center my-2" style={{ color: "red" }}>
            <h3>{t("free_days_title")}</h3>
          </div>

          {/* Error */}
          {showError && (
            <div
              className="col-12 mt-2 text-center"
              style={{
                color: "red",
                fontWeight: "bold",
                background: "bisque",
                borderRadius: "15px",
                marginBottom: "15px"
              }}
            >
              <p>{errorMessage}</p>
            </div>
          )}

          {/* Subscribe Button */}
          {!showMsisdnInput && (
            <div className="row d-flex justify-content-center mx-0 mt-2 px-0">
              <button
                disabled={showSub}
                onClick={confirmSubscribe}
                className="mt-4 btn border-1 rounded-pill btn-signup submit-btn btn-primary text-center"
              >
                {t("subscribe")}
              </button>
            </div>
          )}

          {/* Phone Input */}
          {showMsisdnInput && (
            <div className="text-center my-3">
              <input
                type="tel"
                className="form-control text-center aciq-phone-input"
                placeholder={t("aciq_phone_placeholder")}
                inputMode="numeric"
                autoComplete="tel-national"
                pattern="96477[0-9]{8}"
                maxLength={13}
                dir="ltr"
                value={manualMsisdn}
                onChange={handleManualMsisdnChange}
              />
             
              <button
                type="button"
                className="btn btn-primary mt-3 w-100 rounded-pill text-center"
                disabled={
                  showLoading || !isValidIqAsiacellMsisdn(manualMsisdn)
                }
                onClick={manualSubscribe}
              >
                {t("continue")}
              </button>
            </div>
          )}

          <div className="aciq-worldlink-row">
            <img
              className="aciq-worldlink-brand"
              src={grandLogo}
              alt="World Link"
            />
          </div>

          {/* Description */}
          <div className="text-center mt-2">
           <p style={{ direction: "rtl", fontWeight: "500" }} className="px-0 mb-2">
  {t("description")}
</p> 


            <p style={{ direction: "rtl" }} className="px-0 ">
              {t("terms_prefix")}{" "}
              <Link className="text-decoration-none" to="/aciq-terms-and-conditions">
                {t("terms_link")}
              </Link>
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</Layout>

      {/* {visibleModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3" style={{ borderRadius: "8px", border: "1px solid green" }}>
              <div className="modal-body text-center">
                <p className="fw-bold">من فضلك ارسل 1 الى 2170</p>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
}
